import * as React from 'react';
export const useDelayedBiEvent = (onEventTriggered) => {
    const [timeoutId, setTimeoutId] = React.useState(null);
    const logDelayedEvent = (delay = 2000) => onEventTriggered &&
        setTimeoutId(window.setTimeout(onEventTriggered, delay));
    const interruptDelayedEvent = () => !!timeoutId && clearTimeout(timeoutId);
    React.useEffect(() => {
        return () => {
            interruptDelayedEvent();
        };
    }, []);
    return { logDelayedEvent, interruptDelayedEvent };
};
//# sourceMappingURL=useDelayedBiEvent.js.map